module.exports = __webpack_public_path__ + "static/media/p4_image4.e5fcb548.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/intro/p4_image4.jpg
// module id = 2524
// module chunks = 0